import React, { forwardRef } from 'react';
import { node, object } from 'prop-types';
import clsx from 'clsx';

import Paper from '@material-ui/core/Paper';
import RootRef from '@material-ui/core/RootRef';

import defaultClasses from './TabContent.module.css';

const TabContent = forwardRef(({ classes, children, ...props }, ref) => {
    let Wrapper = React.Fragment;
    let wrapperProps = {};
    if (ref) {
        Wrapper = RootRef;
        wrapperProps = {
            rootRef: ref
        };
    }
    return (
        <Wrapper {...wrapperProps}>
            <Paper
                classes={{
                    ...classes,
                    root: clsx(defaultClasses.root, classes.root)
                }}
                {...props}
                ref={ref}
            >
                {children}
            </Paper>
        </Wrapper>
    );
});

TabContent.defaultProps = {
    classes: {}
};

TabContent.propTypes = {
    children: node,
    classes:  object
};

export default TabContent;
